import React from "react"
import styles from "./ProgressCircle.module.css"

const ProgressCircle = ({ percent, backgroundColor }) => {
  const progress = Math.min(Math.max(percent, 0), 100)

  const getProgressClass = () => {
    if (progress < 25) {
      return styles.under25
    } else if (progress < 50) {
      return styles.under50
    } else {
      return ""
    }
  }

  // See https://stackoverflow.com/a/29512804
  const asDecimal = progress / 100
  const dasharray = `${251 * asDecimal}, ${251 - 251 * asDecimal}`
  return (
    <svg id="svg" width={100} height={100}>
      <circle cx="50" cy="50" r="45" fill={backgroundColor} />
      <path
        className={styles.ring}
        fill="none"
        strokeLinecap="round"
        strokeWidth="8"
        stroke="#fff"
        strokeDasharray="251, 251"
        d="M50 10
           a 40 40 0 0 1 0 80
           a 40 40 0 0 1 0 -80"
      />
      <path
        data-testid="progress-stroke"
        className={`${styles.progress} ${getProgressClass()}`}
        fill="none"
        strokeLinecap="round"
        strokeWidth="8"
        stroke="#fff"
        strokeDasharray={dasharray}
        d="M50 10
           a 40 40 0 0 1 0 80
           a 40 40 0 0 1 0 -80"
      />
    </svg>
  )
}

ProgressCircle.defaultProps = {
  percent: 0,
  backgroundColor: "white",
}

export default ProgressCircle
